module.exports = __webpack_public_path__ + "img/unregistered.03ccd1a4.svg";